"use client";

import Link from "next/link";
import { useState, ReactNode } from "react";
import { usePathname, useRouter } from "next/navigation";
import Dropdown from "./Dropdown";
import { Tab } from "@/types/tabs";

interface TabsProps {
  tabs: Tab[];
  pageSlug: string;
  children?: ReactNode;
}

const Tabs = ({ tabs, pageSlug, children }: TabsProps) => {
  const pathname = usePathname();
  const { push: routerPush } = useRouter();

  const slugFromUrl = pathname
    ?.split("/")
    .filter((str) => !!str && !pageSlug?.split("/").includes(str))
    .join("");

  const tabBySlug = tabs?.find((tab: Tab) => tab?.slug === slugFromUrl);

  const [selectedTab, setSelectedTab] = useState<string>(
    tabBySlug?.value || tabs?.[0]?.value,
  );

  const onClickSelect = (tab: Tab) => {
    setSelectedTab(tab?.value);
    routerPush(
      `/${pageSlug}/${
        pageSlug?.split("/").includes(tab?.slug) ? "" : tab?.slug
      }`,
    );
  };

  return (
    <div className="grid-container">
      <div className="col-start-1 col-span-4 lg:col-start-2 lg:col-span-14 2xl:col-start-4 2xl:col-span-26">
        {tabs?.length > 0 && (
          <div className="flex md:hidden justify-center mt-5 mb-[30px]">
            <Dropdown
              defaultValue={tabs?.find((t: Tab) => t?.value === selectedTab)}
              onChange={(tab: any) => onClickSelect(tab)}
              options={tabs}
            />
          </div>
        )}

        {tabs?.length > 0 && (
          <div className="hidden md:flex gap-2.5 list-none mt-5 mx-0 md:mb-10 xl:mb-20 p-0 text-[15px] leading-[1.6] tracking-[0.45px]">
            {tabs?.map((tab: Tab, index: number) => (
              <Link
                key={index}
                href={`/${pageSlug}/${
                  pageSlug?.split("/").includes(tab?.slug) ? "" : tab?.slug
                }`}
                as={`/${pageSlug}/${
                  pageSlug?.split("/").includes(tab?.slug) ? "" : tab?.slug
                }`}
                passHref
                onClick={() => setSelectedTab(tab?.value)}
                className="flex justify-center items-center px-6 py-2.5 rounded-[6px] cursor-pointer bg-tm-c-gray-950 lg:hover:bg-tm-c-gray-700"
                style={{
                  background:
                    tab?.value === selectedTab
                      ? "var(--color-tm-c-gray-700)"
                      : "",
                }}
              >
                {tab?.label}
              </Link>
            ))}
            {children}
          </div>
        )}
      </div>
    </div>
  );
};

export default Tabs;
